<template>
    <div>
        <div v-for="(icard_data, ind) in icard_data" :key="ind">
            <div v-if="icard_data !== ''" class="icard-wrapper">
                <img :src="icard_data.watermark" class="watermark-bg" />
                <div class="content-layer">
                    <center v-if="icard_data.profile_photo_path">
                        <img :src="icard_data.profile_photo_path" class="profile-photo" />
                    </center>
                    <div class="pa-3 details text-center">
                        <h4 style="font-family: 'Times New Roman', Times, serif;">{{ icard_data.name }}</h4>
                        <h5 style="font-family: 'Times New Roman', Times, serif;">{{ icard_data.designation }}</h5>
                        <h4 style="font-family: 'Times New Roman', Times, serif;">Employee Code : {{ icard_data.emp_code }}</h4>
                        <div class="mt-3 mb-3" style="height: 2px;background-color: #f79e31;"></div>
                        <h2 style="color: #c23308; font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;">{{
                            icard_data.school_name }}</h2>
                    </div>
                </div>
            </div>

            <div v-if="icard_data !== ''" class="icard-wrapper">
                <img :src="icard_data.watermark_back" class="watermark-bg" />
                <div class="content-layer2 print-font px-2">
                    <b class="colored-text">Qualification : </b><b>{{ icard_data.emp_qualification }}</b><br>
                    <b class="colored-text">Address : </b><b>{{ icard_data.emp_address }}</b><br>
                    <b class="colored-text">Mobile : </b><b>{{ icard_data.emp_contact }}</b><br>
                    <b class="colored-text">Email : </b><b>{{ icard_data.emp_email_official }}</b><br>
                    <b class="colored-text">D.O.B : </b><b>{{ icard_data.emp_dob }}</b><br>
                    <b class="colored-text">Blood Group : </b><b>{{ icard_data.emp_blood_group }}</b><br>

                    <div v-if="icard_data.is_principal">
                            <img style=" position: absolute;right: 5px;bottom: 70px;" :src="icard_data.director_sign" alt="sign"
                                width="80" height="40" />
                            <span style=" position: absolute;right: 25px;bottom: 45px;"><b>Secretary</b></span>
                            </div>
                            <div v-else>
                            <img style=" position: absolute;right: 5px;bottom: 70px;" :src="icard_data.sign" alt="sign"
                                width="80" height="40" />
                            <span style=" position: absolute;right: 25px;bottom: 45px;"><b>Principal</b></span>
                        </div>
                    <barcode style=" position: absolute; bottom: 40px;" height="40" width="1.6" :value="icard_data.emp_code"
                        displayValue="false">
                    </barcode>
                    <div class="end-div text-center">
                        SANJIVANI
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import VueBarcode from "vue-barcode";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard

export default {
    components: {
        barcode: VueBarcode,
    },
    data: () => ({
        comp_load: false,
        inst_list: null,
        radios: null,
        inst_data: null,
        icard_data: [],
        barcodeValue: "",
        authority: "Principal",
        authority_sign: null,
    }),
    mounted() {
        this.inst_data = JSON.parse(localStorage.getItem("inst_data"));
        this.authority = localStorage.getItem("authority");
        this.icardGenerate();
    },
    methods: {
        print() {
            this.$store.state.drawer = false;
            let that = this;
            window.onafterprint = function () {
                that.$store.state.drawer = true;
            };
            setTimeout(function () {
                window.print();
            }, 100);
        },
        icardGenerate() {
            const data = {
                inst_data: this.inst_data,
            };
            axios
                .post("/Icard/icardGenerate", data)
                .then((res) => {
                    this.icard_data = res.data.icard_data;
                    this.authority_sign = res.data.icard_data[0].director_sign;
                    if (this.authority == "Director") {
                        this.authority = "Founder Director";
                        this.icard_data[0].sign = this.authority_sign;
                    }
                })

                .catch((error) => {
                    console.log("Error", error);
                    alert("Somthing went wrong!!!");
                })
                .finally(() => {
                    this.comp_load = false;
                });
        },
    },
};
</script>

<style scoped>
.content-layer {
    position: absolute;
    top: 90px;
    left: 0;
    width: 100%;
    /* height: 100%; */
    z-index: 2;
}

.content-layer2 {
    position: absolute;
    top: 180px;
    left: 0;
    width: 100%;
    height: 60%;
    z-index: 2;
}

.end-div {
    position: absolute !important;
    bottom: -5px !important;
    z-index: 2;
    color: #eb7d01;
    margin-left: 50px;
    font-weight: 700;
    font-size: 40px;
    letter-spacing: 1px;
}
.print-font{
    font-size: 15px;
}

.colored-text {
    color: #eb7d00;
}

.icard-wrapper {
    position: relative;
    width: 325px;
    height: 488px;
}

@media print {
    .pagebreak {
        page-break-before: always !important;
    }
    @page {
        margin: -0.2645833mm;
        size: 57mm 86mm;
    }
}

.watermark-bg {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;
    object-fit: cover;
}

.profile-photo {
    width: 130px;
    height: 130px;
    /* object-fit: cover; */
    border-radius: 50%;
    border: 2px solid #f79d31;
}
</style>
